import { Text } from "@react-pdf/renderer";
import { useMemo } from "react";

const PdfLabel = ({ children, bold = true, style }) => {
  const styles = useMemo(() => {
    return {
      fontSize: 9,
      fontWeight: bold ? "bold" : "normal",
      color: "#666666",
      ...style,
    };
  }, [style, bold]);

  return <Text style={styles}>{children}</Text>;
};

export default PdfLabel;
